import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import * as translationTH from './core/locales/th/translation.json'
import * as translationEN from './core/locales/en/translation.json'

const resources = {
  TH: {
    translation: translationTH
  },
  EN: {
    translation: translationEN
  }
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'TH',
  debug: true
})

export default i18n
